module.exports = __webpack_public_path__ + "img/IMG-20191208-WA0073.4cb81fff.jpg";